import { Box, TextField, Checkbox, Typography } from "flux";
import { TrackingIdInclusionState } from "../../types/ad-asset-group";

interface DestinationUrlFieldProps {
  label: string;
  value: string;
  field: keyof TrackingIdInclusionState;
  isTrackingIdIncluded: boolean;
  onValueChange: (field: keyof TrackingIdInclusionState, value: string) => void;
  onTrackingIdInclusionChange: (field: keyof TrackingIdInclusionState, included: boolean, currentValue: string) => void;
  dataDogIdentifier: string;
  fullWidth?: boolean;
}

export default function DestinationUrlField({
  label,
  value,
  field,
  isTrackingIdIncluded,
  onValueChange,
  onTrackingIdInclusionChange,
  dataDogIdentifier,
  fullWidth = true
}: DestinationUrlFieldProps) {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Checkbox
          checked={isTrackingIdIncluded}
          onChange={(e) => onTrackingIdInclusionChange(field, e.target.checked, value)}
          dataDogIdentifier={`${dataDogIdentifier} tracking id checkbox`}
        />
        <Typography variant="body2">Include tracking ID in {label}</Typography>
      </Box>
      <TextField
        label={label}
        value={value}
        onChange={(e) => onValueChange(field, e.target.value)}
        fullWidth={fullWidth}
        dataDogIdentifier={dataDogIdentifier}
      />
    </Box>
  );
}
